import { startEnglishIqSessionV1Api } from '@repo/sdk';
import { requireEnglishIqResponseData } from './require-english-iq-response-data';

export async function startEnglishIqWebSession(
  locale: string,
  visitorId: string,
  turnstileToken?: string,
) {
  const response = await startEnglishIqSessionV1Api({ locale, turnstileToken, visitorId });
  return requireEnglishIqResponseData(response.data.data);
}
